import type {
	checkBoxMapConfig,
	sectionMapConfig,
} from './GoodsAndServicesMapConfig'
import { PriceTotalKey } from './GoodsAndServicesMapConfig'
import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

const Pb = PbSubcategory

export const gServiceMapSubItemsConfig: sectionMapConfig = [
	{
		name: 'gBasicServicesAmt',
		category: Pb.ServiceBasicServicesOfFDAndStaff,
		prop: 'price',
	},
	{
		name: 'gBathingDesc',
		category: Pb.ServiceBodyPreparation,
		prop: 'shortDescription',
	},
	{
		name: 'gBathingAmt',
		category: Pb.ServiceBodyPreparation,
		prop: 'price',
	},
	{
		name: 'gOtherPrepDesc',
		category: Pb.ServiceOtherBodyPreparation,
		prop: 'shortDescription',
	},
	{
		name: 'gOtherPrepAmt',
		category: Pb.ServiceOtherBodyPreparation,
		prop: 'price',
	},
	{
		name: 'gVisitationVal',
		category: Pb.ServiceVisitationViewing,
		prop: 'shortDescription',
	},
	{
		name: 'gVisitationAmt',
		category: Pb.ServiceVisitationViewing,
		prop: 'price',
	},
	{
		name: 'gFuneralDesc',
		category: Pb.ServiceFuneralMemorial,
		prop: 'shortDescription',
	},
	{
		name: 'gFuneralAmt',
		category: Pb.ServiceFuneralMemorial,
		prop: 'price',
	},
	{
		name: 'gMemorialServiceDesc',
		category: Pb.ServiceMemorialService,
		prop: 'shortDescription',
	},
	{
		name: 'gMemorialServiceAmt',
		category: Pb.ServiceMemorialService,
		prop: 'price',
	},
	{
		name: 'gGravesideServiceDesc',
		category: Pb.ServiceGravesideService,
		prop: 'shortDescription',
	},
	{
		name: 'gGravesideServiceAmt',
		category: Pb.ServiceGravesideService,
		prop: 'price',
	},
	{
		name: 'gCosmeticBeauticianDesc',
		category: Pb.ServiceCosmeticBeautician,
		prop: 'shortDescription',
	},
	{
		name: 'gCosmeticBeauticianAmt',
		category: Pb.ServiceCosmeticBeautician,
		prop: 'price',
	},
	{
		name: 'gDressingCasketingDesc',
		category: Pb.ServiceDressingCasketing,
		prop: 'shortDescription',
	},
	{
		name: 'gDressingCasketingAmt',
		category: Pb.ServiceDressingCasketing,
		prop: 'price',
	},
	{
		name: 'gOtherPrepDesc',
		category: Pb.ServiceOtherBodyPreparation,
		prop: 'shortDescription',
	},
	{
		name: 'gOtherPrepAmt',
		category: Pb.ServiceOtherBodyPreparation,
		prop: 'price',
	},
	{
		name: 'gPrayerServiceDesc',
		category: Pb.ServiceRosaryOrPrayer,
		prop: 'shortDescription',
	},
	{
		name: 'gPrayerServiceAmt',
		category: Pb.ServiceRosaryOrPrayer,
		prop: 'price',
	},
	{
		name: 'gLeadCarDesc',
		category: Pb.TransportationLeadCar,
		prop: 'shortDescription',
	},
	{
		name: 'gLeadCarAmt',
		category: Pb.TransportationLeadCar,
		prop: 'price',
	},
	{
		name: 'gClergyCarDesc',
		category: Pb.TransportationClergyCar,
		prop: 'shortDescription',
	},
	{
		name: 'gClergyCarAmt',
		category: Pb.TransportationClergyCar,
		prop: 'price',
	},
	{
		name: 'gPallbearerCarDesc',
		category: Pb.TransportationPallbearerCar,
		prop: 'shortDescription',
	},
	{
		name: 'gPallbearerCarAmt',
		category: Pb.TransportationPallbearerCar,
		prop: 'price',
	},
	{
		name: 'gForwardingRemainsDesc',
		category: Pb.ServiceForwardingRemains,
		prop: 'shortDescription',
	},
	{
		name: 'gForwardingRemainsAmt',
		category: Pb.ServiceForwardingRemains,
		prop: 'price',
	},
	{
		name: 'gReceivingRemainsDesc',
		category: Pb.ServiceReceivingRemains,
		prop: 'shortDescription',
	},
	{
		name: 'gReceivingRemainsAmt',
		category: Pb.ServiceReceivingRemains,
		prop: 'price',
	},
	{
		name: 'gTransferMileRadiusVal',
		category: Pb.TransportationTransfer,
		prop: 'mileRadiusForStandardService',
	},
	{
		name: 'gTransferMileRadiusAmt',
		category: Pb.TransportationTransfer,
		prop: 'price',
	},
	{
		name: 'gHearseMileRadiusDesc',
		category: Pb.TransportationHearse,
		prop: 'shortDescription',
	},
	{
		name: 'gHearseMileRadiusAmt',
		category: Pb.TransportationHearse,
		prop: 'price',
	},
	{
		name: 'gFamilyCarLimoDesc',
		category: Pb.TransportationFamilyCarLimo,
		prop: 'shortDescription',
	},
	{
		name: 'gFamilyCarLimoMileRadiusAmt',
		category: Pb.TransportationFamilyCarLimo,
		prop: 'price',
	},
	{
		name: 'gUtilityVehicleVanDesc',
		category: Pb.TransportationUtilityVehicleVan,
		prop: 'shortDescription',
	},
	{
		name: 'gUtilityVehicleVanAmt',
		category: Pb.TransportationUtilityVehicleVan,
		prop: 'price',
	},
	{
		name: 'gDirectBurialAmt',
		category: Pb.DispositionDirectBurial,
		prop: 'price',
	},
	{
		name: 'gDirectCremationAmt',
		category: Pb.DispositionDirectCremation,
		prop: 'price',
	},
	{
		name: 'gTransportationOtherDesc',
		category: `${PbProductType.Transportation}-${Pb.Other}`,
		prop: 'shortDescription',
	},
	{
		name: 'gTransportationOtherAmt',
		category: `${PbProductType.Transportation}-${Pb.Other}`,
		prop: 'price',
	},
	{
		name: 'gOtherFacilitiesDesc',
		category: Pb.ServiceOtherFacilities,
		prop: 'shortDescription',
	},
	{
		name: 'gOtherFacilitiesAmt',
		category: Pb.ServiceOtherFacilities,
		prop: 'price',
	},
	{
		name: 'gOtherServicesLine1Desc',
		category: `${PbProductType.Service}-${Pb.Other}`,
		prop: 'shortDescription',
	},
	{
		name: 'gOtherServicesLine1Amt',
		category: `${PbProductType.Service}-${Pb.Other}`,
		prop: 'price',
	},
	{
		name: 'gOtherServicesLine2Desc',
		category: `${PbProductType.Transportation}-${Pb.Other2}`,
		prop: 'name',
	},
	{
		name: 'gOtherServicesLine2Amt',
		category: `${PbProductType.Transportation}-${Pb.Other2}`,
		prop: 'price',
	},
	{
		name: 'packageName',
		category: `${PbProductType.Package}`,
		prop: 'name',
	},
	{
		name: 'gEmbalmingAmt',
		category: Pb.ServiceEmbalming,
		prop: 'price',
	},
	{
		name: 'gRefrigerationAmt',
		category: Pb.ServiceRefrigeration,
		prop: 'price',
	},
	{
		name: 'gRefrigerationDaysVal',
		category: Pb.ServiceRefrigeration,
		prop: 'numberOfDays',
	},
]

export const gMerchandiseMapConfig: sectionMapConfig = [
	{
		name: 'gUrnModelDesc',
		category: Pb.MerchandiseUrn,
		prop: 'modelNameNumber',
	},
	{
		name: 'gUrnManufacturerDesc',
		category: Pb.MerchandiseUrn,
		prop: 'productManufacturer',
	},
	{
		name: 'gUrnConstructedOfDesc',
		category: Pb.MerchandiseUrn,
		prop: 'exteriorDescription',
	},
	{ name: 'gUrnAmt', category: Pb.MerchandiseUrn, prop: 'price' },
	{
		name: 'gAltContainerDesc',
		category: Pb.MerchandiseAlternativeContainer,
		prop: 'shortDescription',
	},
	{
		name: 'gAltContainerAmt',
		category: Pb.MerchandiseAlternativeContainer,
		prop: 'price',
	},
	{
		name: 'gShippingContainerDesc',
		category: Pb.MerchandiseShippingContainer,
		prop: 'shortDescription',
	},
	{
		name: 'gShippingContainerAmt',
		category: Pb.MerchandiseShippingContainer,
		prop: 'price',
	},
	{
		name: 'gStationaryCardsDesc',
		category: Pb.MerchandiseStationaryCards,
		prop: 'shortDescription',
	},
	{
		name: 'gStationaryCardsVal',
		category: Pb.MerchandiseStationaryCards,
		prop: 'quantity',
	},
	{
		name: 'gStationaryCardsAmt',
		category: Pb.MerchandiseStationaryCards,
		prop: 'price',
	},
	{
		name: 'gMemorialBookDesc',
		category: Pb.MerchandiseMemorialBook,
		prop: 'shortDescription',
	},
	{
		name: 'gMemorialBookVal',
		category: Pb.MerchandiseMemorialBook,
		prop: 'quantity',
	},
	{
		name: 'gMemorialBookAmt',
		category: Pb.MerchandiseMemorialBook,
		prop: 'price',
	},
	{
		name: 'gAckCardsDesc',
		category: Pb.MerchandiseAckCards,
		prop: 'shortDescription',
	},
	{
		name: 'gAckCardsVal',
		category: Pb.MerchandiseAckCards,
		prop: 'quantity',
	},
	{
		name: 'gAckCardsAmt',
		category: Pb.MerchandiseAckCards,
		prop: 'price',
	},
	{
		name: 'gClothingDesc',
		category: Pb.MerchandiseClothing,
		prop: 'shortDescription',
	},
	{
		name: 'gClothingAmt',
		category: Pb.MerchandiseClothing,
		prop: 'price',
	},
	{
		name: 'gOtherMerchandiseLine1Desc',
		category: `${PbProductType.Merchandise}-${Pb.Other}`,
		prop: 'shortDescription',
	},
	{
		name: 'gOtherMerchandiseLine1Amt',
		category: `${PbProductType.Merchandise}-${Pb.Other}`,
		prop: 'price',
	},
]

export const ngCashAdvanceMapConfig: sectionMapConfig = [
	{
		name: 'ngDeathCertificatesDesc',
		category: Pb.CashAdvanceDeathCertificates,
		prop: 'shortDescription',
	},
	{
		name: 'ngDeathCertificatesAmt',
		category: Pb.CashAdvanceDeathCertificates,
		prop: 'price',
	},
	{
		name: 'ngObituaryNoticePublicationDesc',
		category: Pb.CashAdvanceObituary,
		prop: 'shortDescription',
	},
	{
		name: 'ngObituaryNoticePublicationAmt',
		category: Pb.CashAdvanceObituary,
		prop: 'price',
	},
	{
		name: 'ngFlowersDesc',
		category: Pb.CashAdvanceFlowers,
		prop: 'shortDescription',
	},
	{ name: 'ngFlowersAmt', category: Pb.CashAdvanceFlowers, prop: 'price' },
	{
		name: 'ngHairdresserAmt',
		category: Pb.CashAdvanceHairdresser,
		prop: 'price',
	},
	{
		name: 'ngClergyHonorariumDesc',
		category: Pb.CashAdvanceClergyHonorarium,
		prop: 'shortDescription',
	},
	{
		name: 'ngClergyHonorariumAmt',
		category: Pb.CashAdvanceClergyHonorarium,
		prop: 'price',
	},
	{
		name: 'ngMusicianVocalistDesc',
		category: Pb.CashAdvanceMusicianVocalist,
		prop: 'shortDescription',
	},
	{
		name: 'ngMusicianVocalistAmt',
		category: Pb.CashAdvanceMusicianVocalist,
		prop: 'price',
	},
	{
		name: 'ngMusicDesc',
		category: Pb.CashAdvanceMusic,
		prop: 'shortDescription',
	},
	{ name: 'ngMusicAmt', category: Pb.CashAdvanceMusic, prop: 'price' },
	{
		name: 'ngCremationServicesDesc',
		category: Pb.CashAdvanceCremationServices,
		prop: 'shortDescription',
	},
	{
		name: 'ngCremationServicesAmt',
		category: Pb.CashAdvanceCremationServices,
		prop: 'price',
	},
	{
		name: 'ngEscortDesc',
		category: Pb.CemeteryEscorts,
		prop: 'shortDescription',
	},
	{ name: 'ngEscortAmt', category: Pb.CemeteryEscorts, prop: 'price' },

	{
		name: 'ngIntermentDesc',
		category: Pb.CemeteryInterment,
		prop: 'shortDescription',
	},
	{ name: 'ngIntermentAmt', category: Pb.CemeteryInterment, prop: 'price' },
	{
		name: 'ngTransportDesc',
		category: Pb.FamilyTravelGeneral,
		prop: 'shortDescription',
	},
	{
		name: 'ngTransportAmt',
		category: Pb.FamilyTravelGeneral,
		prop: 'price',
	},
	{
		name: 'ngAfterwardLocationDesc',
		category: Pb.AfterwardLocation,
		prop: 'shortDescription',
	},
	{
		name: 'ngAfterwardLocationAmt',
		category: Pb.AfterwardLocation,
		prop: 'price',
	},
	{
		name: 'ngCemeterySetupDesc',
		category: `${PbProductType.Cemetery}-${Pb.Other}`,
		prop: 'shortDescription',
	},
	{
		name: 'ngCemeterySetupAmt',
		category: `${PbProductType.Cemetery}-${Pb.Other}`,
		prop: 'price',
	},
]

export const gServiceCheckBoxMapConfig: checkBoxMapConfig = [
	{
		name: 'gServiceTypeFullServiceBurialCheck',
		category: Pb.DispositionFullServiceBurial,
	},
	{
		name: 'gServiceTypeFullServiceCremationCheck',
		category: Pb.DispositionFullServiceCremation,
	},
	{
		name: 'gServiceTypeDirectBurialCheck',
		category: Pb.DispositionDirectBurial,
	},
	{
		name: 'gServiceTypeDirectCremationCheck',
		category: Pb.DispositionDirectCremation,
	},
	{
		name: 'gServiceTypeMemorialServiceCremationCheck',
		category: Pb.DispositionMemorialServiceCremation,
	},
	{
		name: 'gServiceTypeOtherCheck',
		category: `${PbProductType.Disposition}-${Pb.Other}`,
	},
	{ name: 'gEmbalmingCheck', category: Pb.ServiceEmbalming },
	{ name: 'gRefrigerationCheck', category: Pb.ServiceRefrigeration },
]

export const ngCashAdvanceCheckBoxMapConfig: checkBoxMapConfig = [
	{ name: 'ngTransportCheck', category: Pb.FamilyTravelGeneral },
	{ name: 'ngIntermentCheck', category: Pb.CemeteryInterment },
	{
		name: 'ngCemeterySetupCheck',
		category: `${PbProductType.Cemetery}-${Pb.Other}`,
	},
	{
		name: 'ngCremationServicesCheck',
		category: Pb.CashAdvanceCremationServices,
	},
	{
		name: 'ngClergyHonorariumCheck',
		category: Pb.CashAdvanceClergyHonorarium,
	},
	{
		name: 'ngDeathCertificatesCheck',
		category: Pb.CashAdvanceDeathCertificates,
	},
	{ name: 'ngFlowersCheck', category: Pb.CashAdvanceFlowers },
	{
		name: 'ngObituaryNoticePublicationCheck',
		category: Pb.CashAdvanceObituary,
	},
	{ name: 'ngMusicCheck', category: Pb.CashAdvanceMusic },
	{ name: 'ngAfterwardLocationCheck', category: Pb.AfterwardLocation },
	{ name: 'ngEscortCheck', category: Pb.CemeteryEscorts },
	{
		name: 'ngMusicianVocalistCheck',
		category: Pb.CashAdvanceMusicianVocalist,
	},
]

export const priceTotalMapConfig: {
	name: string
	key: PriceTotalKey
}[] = [
	{
		name: 'gServicesTotal',
		key: PriceTotalKey.ServicesTotal,
	},
	{
		name: 'gMerchandiseTotal',
		key: PriceTotalKey.MerchandiseTotal,
	},
	{
		name: 'ngCashAdvanceItemsTotal',
		key: PriceTotalKey.CashAdvanceTotal,
	},
	{
		name: 'gGoodsAndServicesTotal',
		key: PriceTotalKey.GoodsAndServicesTotal,
	},
	{
		name: 'subtotalGoodsAndServices',
		key: PriceTotalKey.FuneralSubtotal,
	},
	{
		name: 'funeralAmountTotal',
		key: PriceTotalKey.FuneralTotal,
	},
]
